<template>
  <div v-bottom="0">
    <div class="twui-subnav" v-if="$store.state.MenuList2th&&$store.state.MenuList2th.length>0">
      <div class="twui-subnav-inner">
        <el-tabs v-model="activeId"   @tab-click="changeMenuList3th">
          <el-tab-pane  @click="changeMenuList3th(item.menuId,item.appType)" v-for="(item) in $store.state.MenuList2th" :label="item.menuName" :key="item.menuId" :name="item.menuId"></el-tab-pane>
      </el-tabs>
      </div>
    </div>
    <!-- 获取对应type下的应用列表 仅在TWPAAS11000000004有效 -->

    <div class="xmenu" v-if="$store.state.typeOfAppList.length>0">
      <el-tabs v-model="$store.state.activeAppId" type="card" @tab-click="getAppMenuList">
          <el-tab-pane v-for="(item) in $store.state.typeOfAppList" :label="item.appName" :key="item.appId" :name="item.appId"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="twui-body-left" v-if="$store.state.MenuList3th&&$store.state.MenuList3th.length>0"  >
      <el-tree  :data="$store.state.MenuList3th" :props="defaultTreeProps" node-key="menuId" class="tw-tree" highlight-current @node-click="changeDoc"></el-tree>
    </div>
    <div class="twui-body-right">
      <Editor></Editor>
    </div>
  </div>
</template>
<script>
import Editor from '../web/doc/component'
export default {
  data () {
    return {
      activeId: '',
      defaultTreeProps: {
        children: 'children',
        label: 'menuName'
      },
      labelPosition: 0,
      getMenutype: 0,
      timer: null,
      appList: [],
      doc: {},
      jsLoadOver: false,
      menuList9th: [],
      tabName: ''
    }
  },
  mounted () {
    this.getAppList()
  },
  methods: {
    activeAppName () {
      return this.$store.state.typeOfAppList[0].appName || ''
    },
    changeDoc (key, keyPat) {
      // console.log(key, 'key')
      for (let a of this.$store.state.MenuList3th) {
        if (a.children === undefined || a.children.length === 0) {
          if (a.menuId === key.menuId) {
            if (a.menuClass === '4') {
              this.$store.commit('hasDoc', true)
              this.$store.commit('changeMenuId', key.menuId)
            }
          }
        } else if (a.children.length > 0) {
          for (let b of a.children) {
            if (b.menuId === key.menuId) {
              if (b.menuClass === '4') {
                this.$store.commit('hasDoc', true)
                this.$store.commit('changeMenuId', key.menuId)
              }
            }
          }
        }
      }
    },
    filterApp (key) {
      let typeList = this.appList.filter((item) => {
        return item.type === key
      })
      this.$store.commit('changeTypeOfAppList', typeList)
      if (typeList.length > 0) {
        this.getAppMenuList({
          name: typeList[0].appId
        })
        // 现在
      }
    },
    getAppMenuList (tab, event) {
      for (let a of this.$store.state.typeOfAppList) {
        if (a.appId === tab.name) {
          this.getMenutype = 1
          this.getDocMenu(a.appId)
        }
      }
    },
    getDocMenu (id) {
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', {
          lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
          appId: id
        })
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            if (
              res.data &&
              res.data.pageInfo &&
              res.data.pageInfo.list &&
              res.data.pageInfo.list.length > 0
            ) {
              if (id) {
                let menuList3th = res.data.pageInfo.list.filter((item) => {
                  return item.menuClass === '3'
                })
                let menuList4th = []
                if (menuList3th.length === 0) {
                  menuList4th = res.data.pageInfo.list.filter((item) => {
                    return item.menuClass === '4'
                  })
                  this.$store.commit('changeMenuId', menuList4th[0].menuId)
                } else {
                  menuList4th = this.formatToTree(
                    res.data.pageInfo.list,
                    menuList3th[0].parentMenuId
                  )
                }
                this.$store.commit('changeMenuList3th', menuList4th)
                this.$store.commit('hasDoc', true)
                this.$store.commit(
                  'changeMenuId',
                  menuList4th[0].children[0].menuId
                )
              }
            } else {
              this.$store.commit('hasDoc', false)
              this.$store.commit('changeMenuList3th', [])
              this.$store.commit('changeMenuId', '')
            }
          } else {
            this.$message.error(res.data.serverResult.resultMessage)
          }
        })
    },
    formatToTree (ary, pid) {
      return ary
        .filter((item) =>
          // 如果没有父id（第一次递归的时候）将所有父级查询出来
          // 这里认为 item.parentId === 0 就是最顶层 需要根据业务调整
          pid === undefined
            ? item.parentMenuId === '0'
            : item.parentMenuId === pid
        )
        .map((item) => {
          // 通过父节点ID查询所有子节点
          item.children = this.formatToTree(ary, item.menuId)
          return item
        })
    },
    changeMenuList3th ({name, index}) {
      this.getMenutype = 0
      let Id = name
      let appType = this.$store.state.MenuList2th[index].appType
      console.log(name, index)
      this.$store.commit('changeActiveId2th', Id)
      if (
        this.$store.state.MenuList2th[0].parentMenuId === 'TWPAAS11000000004'
      ) {
        return this.filterApp(appType)
      }

      let data = [
        {
          lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
          menuId: Id
        },
        {
          lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
          appId: Id
        }
      ]
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', data[this.getMenutype])
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            if (
              res.data &&
              res.data.pageInfo &&
              res.data.pageInfo.list &&
              res.data.pageInfo.list.length > 0
            ) {
              this.$store.commit('hasDoc', true)
              if (Id) {
                let menuList3th = res.data.pageInfo.list.filter((item) => {
                  return item.menuClass === '3'
                })
                let menuList4th = this.formatToTree(
                  res.data.pageInfo.list,
                  menuList3th[0].parentMenuId
                )
                this.$store.commit('changeMenuList3th', menuList4th)
                // 非业务应用下
                if (
                  menuList4th[0] &&
                  menuList4th[0].children &&
                  menuList4th[0].children.length > 0
                ) {
                  this.$store.commit(
                    'changeMenuId',
                    menuList4th[0].children[0].menuId
                  )
                } else {
                  this.$store.commit('changeMenuId', menuList4th[0].menuId)
                }
              }
            } else {
              this.$store.commit('hasDoc', false)
              this.$message.error(res.data.serverResult.resultMessage)
            }
          }
        })
    },

    getAppList () {
      this.axios
        .post('/openapi-uc/app/list', {
          appId: '',
          numPerPage: 999,
          pageNum: 1,
          pageNo: 1,
          osType: '1',
          status: '6',
          userType: '1',
          appName: '',
          sectionId: '',
          subjectId: '',
          type: ''
        })
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            this.appList = res.data.pageInfo.list
          } else {
            this.$message.warning('找不到app数据')
          }
        })
    }
  },
  components: {
    Editor
  }
}
</script>
<style scoped>
.xmenu /deep/.el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
  border: 1px solid #f2f2f2 !important;
}
.xmenu /deep/ .el-tabs__item.is-active {
  color: #ffffff;
  border-radius: 0;
  background-color: #20a0ff;
}
.xmenu /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: 1px solid #f2f2f2 !important;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.tw-tree {
  background: #e5ebf1;
  height: calc(100vh - 100px);
  overflow-y: auto;
}
.xlinkactive {
  border-bottom: 2px solid #0088ff;
}
.xtab-page .xactive {
  padding: 10px 15px;
  border: 1px solid #f2f2f2;
}
.xtab-page .dictive {
  background-color: #0088ff;
  color: aliceblue;
  padding: 10px 15px;
}
.twui-body-right {
  width: 1500px;
}
.nactive {
  padding: 10px;
  margin-left: 15px;
  border: 1px solid #efefef;
}
.nactive:hover {
  color: #409eff;
  border: 1px solid #409eff;
}
.nav3th {
  height: 55px;
}
.app-type-list {
  height: 65px;
  line-height: 55px;
  display: flex;
  text-align: center;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
}
.app-type-list::-webkit-scrollbar{
  /* width: 4px; */
  height: 4px;
}
/* .twui-subnav-inner::-webkit-scrollbar */


.app-type-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.app-type-list ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.twui-subnav-inner {
  margin-left: 20px;
}
.twui-subnav-inner /deep/ .el-tabs__item{
  height: 50px;
  line-height: 50px;
}
.twui-subnav-inner /deep/ .el-tabs__header{
  border: none;
}
</style>


// WEBPACK FOOTER //
// tw-doc.vue?fb63b9d8